const LiveCasinoIcon = () => {
  return (
    <svg width={19} height={21} viewBox="0 0 19 21" fill="white" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 18.3956L18.4405 5.55542C18.7264 4.48849 18.0932 3.39181 17.0263 3.10593L15 2.56299V4.63354L16.5087 5.03778L15 10.6682V18.3956Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2H2L2 19H12V2ZM2 0C0.895431 0 0 0.89543 0 2V19C0 20.1046 0.89543 21 2 21H12C13.1046 21 14 20.1046 14 19V2C14 0.895431 13.1046 0 12 0H2Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.46463 10.0001L6.99971 6.19731L9.53513 10.0002L7.00004 13.803L4.46463 10.0001Z"
        fill="inherit"
      />
    </svg>
  );
};

export default LiveCasinoIcon;
